import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import {
  Circle as CircleStyle,
  Fill,
  Icon,
  Stroke,
  Style,
  Text,
} from "ol/style";
import bollardIcon from "~/assets/img/bollard-icon.svg";
import craneIcon from "~/assets/img/crane-icon.svg";
import electricityIcon from "~/assets/img/electricity-icon.svg";
import fuelIcon from "~/assets/img/fuel-icon.svg";
import otherIcon from "~/assets/img/other-icon.svg";
import waterIcon from "~/assets/img/water-icon.svg";
import { LayerDefaults, LayerTitle } from "../types/layers";
import { readMapSettings } from "./localMapSettings";

interface Return {
  source: VectorSource;
  layer: VectorLayer;
}

export function createPortServiceLayer(drawing?: boolean): Return {
  const source = new VectorSource();
  const title = drawing ? LayerTitle.PortServicesDraw : LayerTitle.PortServices;

  const layer = new VectorLayer({
    source,
    zIndex:
      readMapSettings("layers", title)?.zIndex ?? LayerDefaults[title].zIndex,
    visible:
      readMapSettings("layers", title)?.visible ?? LayerDefaults[title].visible,
    style: (feature) => {
      let icon = window.location.origin;

      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      switch (parseInt(feature.get("portServiceType"), 10)) {
        case 1:
          icon += waterIcon; // water
          break;
        case 2:
          icon += fuelIcon; // fuel
          break;
        case 3:
          icon += bollardIcon; // bollard
          break;
        case 4:
          icon += electricityIcon; // electricity
          break;
        case 5:
          icon += craneIcon; // crane
          break;
        case 6:
        default:
          icon += otherIcon; // other
          break;
      }

      return drawing
        ? new Style({
            fill: new Fill({
              color: "rgba(255, 255, 255, 0.2)",
            }),
            stroke: new Stroke({
              color: "#6ffc03",
              width: 2,
            }),
            image: new CircleStyle({
              radius: 7,
              fill: new Fill({
                color: "#6ffc03",
              }),
            }),
            text: new Text({
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              text: feature.get("name") ?? "",
              // Hidden, for now
              scale: 0,
            }),
          })
        : new Style({
            image: new Icon({
              opacity: 1,
              src: icon,
              scale: 1,
            }),
          });
    },
  });
  layer.set("title", title);

  return { source, layer };
}
